/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { string, func, object } from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';

const styles = (theme) => ({
    quantityContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '36px',
        marginBottom: '2px',
        '@media screen and (max-width: 600px)': {
            justifyContent: 'center',
            marginTop: '26px',
            position: 'relative',
            marginBottom: '5px',
        },
    },
    label: {
        fontSize: 16,
        lineHeight: '20px',
        marginRight: 18,

    },
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '83px',
        minWidth: '83px',
        border: '1px solid #C4C4C4',
        borderRadius: '3px',
        padding: '4px',
    },
    addIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        margin: '0',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
    },
    inputField: {
        width: '24px',
        borderRadius: '4px',
        margin: '0 10%',
        padding: '4px 0px',
        textAlign: 'center',
        border: 'unset',
        boxShadow: '1px 1px 3px 1px #00000033 inset',
        fontSize: '14px',
        lineHeight: '20px',
        fontFamily: 'LatoBold',
        outlineColor: 'transparent',
    },
    removeIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        margin: '0',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
    },
    disabledButton: {
        '& svg': {
            fill: '#9D9D9D',
            cursor: 'default',
        },
    },
    errorMessage: {
        color: theme.palette.cms?.errorMessage || '#DF3030',
        marginLeft: '10px',
        fontSize: '14px',
        lineHeight: '16px',
        fontFamily: 'LatoBold, Lato, Arial, Verdana, sans-serif',
        '@media screen and (max-width: 600px)': {
            position: 'absolute',
            bottom: '-18px',
        },
    },
});

const ProductQuantityV2 = ({
    quantity,
    setProductQuantity,
    classes,
}) => {
    const [textFieldValue, setTextFieldValue] = useState(quantity);
    const [errorMessage, setErrorMessage] = useState(false);
    const handleTextFieldChange = (e) => {
        // RegEx to get range between 1 - 99
        const rangeRegex = (/^[1-9][0-9]?$|^99$/);
        if (rangeRegex.test(e.target.value) || e.target.value === '') {
            setTextFieldValue(Number(e.target.value));
            setErrorMessage(false);
        }
    };

    useEffect(() => {
        setTextFieldValue(quantity);
    }, [quantity]);
    const handleBlur = () => {
        const value = (textFieldValue === 0 || textFieldValue === '') ? '1' :  textFieldValue;
        setProductQuantity(value);
        setTextFieldValue(value);
    };
    const addProductQuantity = () => {
        if (Number(quantity) === 99) {
            setErrorMessage(true);
        } else {
            setProductQuantity(Number(quantity) + 1);
            setErrorMessage(false);
        }
    };
    return (
        <div className={classes.quantityContainer}>
            <Typography className={classes.label}>Quantity:</Typography>

            <div
                className={classes.mainContainer}
            >
                <button
                    type="button"
                    data-testid="decrementIcon"
                    className={quantity === 1 ? `${classes.disabledButton} ${classes.removeIcon}` : classes.removeIcon}
                    onClick={() => {
                        setProductQuantity(Number(quantity) - 1);
                        setErrorMessage(false);
                    }}
                    disabled={quantity === 1}
                    aria-label="Remove"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <rect x="12" y="5.33337" width="1.33333" height="11" rx="0.5" transform="rotate(90 12 5.33337)" fill="#555555" stroke="#555555" />
                    </svg>
                </button>
                <input
                    type="text"
                    name="quantity"
                    label="quantity"
                    title="quantity"
                    onChange={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleTextFieldChange(e);
                    }}
                    onBlur={() => {
                        handleBlur();
                    }}
                    value={textFieldValue || ''}
                    className={classes.inputField}
                />
                <button
                    type="button"
                    data-testid="incrementIcon"
                    className={classes.addIcon}
                    onClick={() => {
                        addProductQuantity();
                    }}
                    aria-label="Add"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <rect x="6.00024" y="0.5" width="1" height="11" rx="0.5" fill="#555555" stroke="#555555" />
                        <rect x="12" y="5.64282" width="1" height="11" rx="0.5" transform="rotate(90 12 5.64282)" fill="#555555" stroke="#555555" />
                    </svg>
                </button>
            </div>
            {errorMessage && <span className={classes.errorMessage}>Maximum quantity 99 allowed</span>}
        </div>
    );
};

ProductQuantityV2.propTypes = {
    quantity: string.isRequired,
    setProductQuantity: func.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(ProductQuantityV2);
